import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "@/components/Hero";
import TickerStrip from "@/components/TickerStrip";
import CategoryGrid from "@/components/CategoryGrid";
import FeaturedProducts from "@/components/FeaturedProducts";
import CustomOrders from "@/components/CustomOrders";
import Manifesto from "@/components/Manifesto";

export default function HomePage() {
    const { hash } = useLocation();

    useEffect(() => {
        if (hash) {
            setTimeout(() => {
                document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" });
            }, 400);
        }
    }, [hash]);

    return (
        <main data-testid="home-page">
            <Hero />
            <TickerStrip />
            <CategoryGrid />
            <FeaturedProducts />
            <CustomOrders />
            <Manifesto />
        </main>
    );
}
